export var newEvent = function newEvent(_ref) {
  var event = _ref.event,
      _ref$bubbles = _ref.bubbles,
      bubbles = _ref$bubbles === void 0 ? true : _ref$bubbles,
      _ref$cancelable = _ref.cancelable,
      cancelable = _ref$cancelable === void 0 ? true : _ref$cancelable;
  if (typeof window.Event === "function") return new window.Event(event, {
    bubbles: bubbles,
    cancelable: cancelable
  });
  var e = document.createEvent("Event");
  e.initEvent(event, bubbles, cancelable);
  return e;
};
export var trigger = function trigger(e, event) {
  return e.dispatchEvent(newEvent({
    event: event
  }));
};